import { render, staticRenderFns } from "./fa88c1c8-a88a-4c25-93ab-f5c9126ebaa6.vue?vue&type=template&id=cf07d2e0&scoped=true"
import script from "./fa88c1c8-a88a-4c25-93ab-f5c9126ebaa6.vue?vue&type=script&lang=ts"
export * from "./fa88c1c8-a88a-4c25-93ab-f5c9126ebaa6.vue?vue&type=script&lang=ts"
import style0 from "./fa88c1c8-a88a-4c25-93ab-f5c9126ebaa6.vue?vue&type=style&index=0&id=cf07d2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf07d2e0",
  null
  
)

export default component.exports